import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth";
import { useCart } from "../cart";
import { useSeo } from "../ui";
import { LoginRequired } from "./Cart";
import { CardDone } from "./Checkout";
import { cancelUnpaid, completePayment, takePending } from "../pay";

/* 모바일 카드결제창이 끝나고 돌아오는 곳 — 포트원이 ?paymentId=…(실패면 &code=…&message=…)를 붙여 준다.
   서버가 포트원에 결제를 조회해 확인한다(app/orders.py pay_complete). */
export default function CheckoutComplete() {
  useSeo({ title: "결제 확인 | I.META", description: "카드결제 확인", path: "/checkout/complete", noindex: true });
  const [params] = useSearchParams();
  const { member, ready } = useAuth();
  const cart = useCart();
  const [state, setState] = useState({ phase: "checking" });
  const started = useRef(false);

  const paymentId = params.get("paymentId") || "";
  const code = params.get("code");
  const message = params.get("message");

  useEffect(() => {
    if (!ready || !member || started.current) return;
    started.current = true;
    const pending = takePending() || {};
    if (!paymentId) {
      setState({ phase: "error", message: "결제 정보가 없습니다. MY 페이지에서 주문 상태를 확인해 주세요." });
      return;
    }
    if (code) {
      if (pending.order_no) cancelUnpaid(pending.order_no);
      setState({ phase: "error", message: message || "결제가 완료되지 않았습니다." });
      return;
    }
    completePayment(paymentId)
      .then((order) => {
        if (pending.fromCart && !order.test_only) cart.clear(); // 심사용 테스트 결제는 주문이 확정되지 않았다
        setState({ phase: "done", order, email: pending.email || "" });
      })
      .catch((err) => setState({ phase: "error", message: err.message }));
  }, [ready, member, paymentId, code, message, cart]);

  if (!ready) return <section className="section shop"><p className="note-line">불러오는 중…</p></section>;
  if (!member) return <LoginRequired title="결제 확인" />;

  return (
    <section className="section shop">
      {state.phase === "checking" && <p className="note-line">결제를 확인하고 있습니다…</p>}
      {state.phase === "done" && <CardDone order={state.order} email={state.email} />}
      {state.phase === "error" && (
        <div className="order-done">
          <h1 className="shop__title">결제가 완료되지 않았습니다</h1>
          <p className="order-done__desc">{state.message}</p>
          <div className="order-done__actions">
            <Link to="/cart" className="btn btn--ghost">장바구니로</Link>
            <Link to="/my?tab=orders" className="btn btn--primary">주문내역 보기</Link>
          </div>
        </div>
      )}
    </section>
  );
}
